import * as React from "react";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function InfoDialog({
  open,
  setOpen,
  dialogTitle,
  DialogBody,
  showCiuLogo = false,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      aria-describedby="info-dialog"
      PaperProps={{ sx: { borderRadius: 0 } }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {dialogTitle}
          <IconButton
            aria-label="Close Information"
            onClick={handleClose}
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "white" }}>
        <DialogContentText
          id="alert-dialog-slide-description"
          sx={{ color: "black", pt: 2 }}
          component="div"
        >
          <DialogBody />
        </DialogContentText>
        {showCiuLogo && (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <img
              width={180}
              src="./logo_ciu.svg"
              alt="City Intelligence Logo"
            />
            <Typography variant="caption">
              Map designed and developed by City Intelligence
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
